module.exports = __webpack_public_path__ + "4920828e7c24fb9a543ab75d3c7a9465.png";